var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-top":"10px","margin-bottom":"20px","display":"inline-block"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"#00a3dd"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }